angular.module('dpw.components').component('dpwAppProfileListTable', {
    bindings: {
        orgId: '<?'
    },
    templateUrl: 'dpw-app-profile-list-table.html',
    controller: ['$scope', '$location', 'dpwAppProfileListService',
        function ($scope, $location, dpwAppProfileListService) {
            var self = this;

            self.appProfileList = [];
            self.isEmptyList = function () {
                var list = self.appProfileList || [];
                return list.length === 0;
            };

            self.$onChanges = function (changes) {
                if (!RCDPW.isAdminSite) {
                    self.render();
                    return;
                }

                if (!changes.orgId.isFirstChange() && RCDPW.isAdminSite) {
                    self.render();
                }
            };

            self.render = function (options) {
                dpwAppProfileListService.fetchList({
                    orgId: self.orgId
                }).then(function (data) {
                    self.appProfileList = data.records;
                    if (self.isEmptyList()) {
                        self.noAppProfiles = 'No app profiles.';
                    }
                    if (options && _.isFunction(options.callback)) {
                        options.callback();
                    }
                });
            };
        }]
});
